module.exports = __webpack_public_path__ + "img/image01_sp.55a4b565.jpg";